// Application constants
export const APP_CONFIG = {
  API_BASE_URL: 'https://digilocker.srpfpunegroup1.in/api',
  APP_NAME: 'DigiLocker Issuer',
  VERSION: '1.0.0',
};

// Document types
export const DOCUMENT_TYPES = {
  IDCRD: 'ID Card',
  CERT: 'Certificate',
  DEGREE: 'Degree',
  MARKSHEET: 'Marksheet',
  OTHER: 'Other',
};

// Document statuses
export const DOCUMENT_STATUSES = {
  ACTIVE: 'active',
  REVOKED: 'revoked',
  EXPIRED: 'expired',
};

// Gender options
export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
];

// Department options
export const DEPARTMENT_OPTIONS = [
  'IT Department',
  'Finance Department',
  'HR Department',
  'Operations Department',
  'Marketing Department',
  'Legal Department',
  'Administration',
];

// Designation options
export const DESIGNATION_OPTIONS = [
  'Software Engineer',
  'Senior Software Engineer',
  'Manager',
  'Senior Manager',
  'Director',
  'Analyst',
  'Specialist',
  'Coordinator',
  'Executive',
  'Assistant',
];

// Form validation messages
export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_MOBILE: 'Please enter a valid mobile number',
  INVALID_DATE: 'Please enter a valid date',
  DUPLICATE_EMPLOYEE_ID: 'Employee ID already exists',
  DUPLICATE_DOCUMENT_ID: 'Document ID already exists',
};

// Success messages
export const SUCCESS_MESSAGES = {
  EMPLOYEE_CREATED: 'Employee created successfully',
  EMPLOYEE_UPDATED: 'Employee updated successfully',
  EMPLOYEE_DELETED: 'Employee deleted successfully',
  DOCUMENT_CREATED: 'Document created successfully',
  DOCUMENT_UPDATED: 'Document updated successfully',
  DOCUMENT_DELETED: 'Document deleted successfully',
  CONSENT_UPDATED: 'Consent updated successfully',
  STATUS_UPDATED: 'Status updated successfully',
};

// Error messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  NOT_FOUND: 'Resource not found',
  UNAUTHORIZED: 'Unauthorized access',
  VALIDATION_ERROR: 'Please check your input and try again',
};
